interface Props {
  readonly width?: string
  readonly height?: string
}

export default function DocIcon({ width = 'auto', height = 'auto' }: Props): JSX.Element {
  return (
    <svg
      id="doc_icon"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      data-testid="docIcon"
    >
      <rect id="Rectangle_4250" data-name="Rectangle 4250" width="16" height="16" opacity="0" />
      <g id="Path_25073" data-name="Path 25073" transform="translate(2)" fill="none">
        <path
          d="M 11.5 15.5 L 0.5 15.5 L 0.5 0.5 L 7.792900085449219 0.5 L 11.5 4.207099914550781 L 11.5 15.5 Z"
          stroke="none"
        />
        <path
          d="M 1 1 L 1 15 L 11 15 L 11 4.414219856262207 L 7.585780143737793 1 L 1 1 M 0 0 L 8 0 L 12 4 L 12 16 L 0 16 L 0 0 Z"
          stroke="none"
          fill="gray"
        />
      </g>
      <g id="Path_25072" data-name="Path 25072" transform="translate(9)" fill="none">
        <path d="M0,0H1L5,4V5H0Z" stroke="none" />
        <path
          d="M 1 1.414220094680786 L 1 4 L 3.585780143737793 4 L 1 1.414220094680786 M 0 0 L 1 0 L 5 4 L 5 5 L 0 5 L 0 0 Z"
          stroke="none"
          fill="gray"
        />
      </g>
      <text transform="translate(3 9)" fontSize="14" fontFamily="FiraGO-Regular, FiraGO">
        <tspan x="0" y="0" />
      </text>
      <g
        id="Rectangle_4275"
        data-name="Rectangle 4275"
        transform="translate(0 6)"
        fill="none"
        stroke="gray"
        strokeWidth="1"
      >
        <rect width="16" height="8" stroke="none" />
        <rect x="0.5" y="0.5" width="15" height="7" fill="none" />
      </g>
      <path
        id="Path_25077"
        data-name="Path 25077"
        d="M-4.509,0a1.971,1.971,0,0,0,2.16-2A1.969,1.969,0,0,0-4.515-4H-6.2V0Zm-.654-3.1h.654A1.025,1.025,0,0,1-3.405-2,1.063,1.063,0,0,1-4.515-.9h-.648ZM-2.037-2A2.037,2.037,0,0,0,.1.072,2.032,2.032,0,0,0,2.241-2,2.032,2.032,0,0,0,.1-4.068,2.037,2.037,0,0,0-2.037-2ZM1.191-2A1.082,1.082,0,0,1,.1-.84,1.083,1.083,0,0,1-.987-2,1.08,1.08,0,0,1,.1-3.156,1.079,1.079,0,0,1,1.191-2ZM4.7.072A1.873,1.873,0,0,0,6.471-1l-.888-.42A.971.971,0,0,1,4.7-.84,1.1,1.1,0,0,1,3.609-2,1.1,1.1,0,0,1,4.7-3.156a.971.971,0,0,1,.888.582l.888-.42A1.861,1.861,0,0,0,4.7-4.068,2.035,2.035,0,0,0,2.559-2,2.038,2.038,0,0,0,4.7.072Z"
        transform="translate(8 12)"
        fill="gray"
      />
    </svg>
  )
}
